import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { ContentType } from '@entries/content-types'
import ContentfulCta from '@entries/contentful-cta'
import { withDisplayName } from '@hocs/with-display-name'
import { heading2ConversionArea } from '@render-node/heading-2-conversion-area'
import { spanGreen } from '@render-node/span-green'
import { Entry } from '@resolvers/entry'
import RichText from '@resolvers/rich-text'
import { ContentfulPageSectionStyle } from '@typings/contentful-page-section-template'
import { SectionTemplate } from '@ui/section-template'
import { clsx } from 'clsx'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulConversionArea: Utils.EntryFC<
  Queries.ContentfulConversionAreaFragment
> = ({ content: { title, cta }, entryInspectorProps, fieldInspectorProps }) => (
  <div {...entryInspectorProps()}>
    <SectionTemplate style={ContentfulPageSectionStyle.REFRESH_BLUE_BACKGROUND}>
      <div className={clsx('m-auto mb-[3.75rem] max-w-[776px]')}>
        <RichText
          className="text-balance"
          {...fieldInspectorProps({
            fieldId: 'title',
          })}
          content={title}
          options={{
            renderMark: {
              [MARKS.BOLD]: spanGreen,
            },
            renderNode: {
              [BLOCKS.PARAGRAPH]: heading2ConversionArea,
            },
          }}
        />
      </div>
      <div className="text-center">
        <Entry
          content={cta}
          mapping={{
            [ContentType.ContentfulCta]: ContentfulCta,
          }}
        />
      </div>
    </SectionTemplate>
  </div>
)

export const query = graphql`
  fragment ContentfulConversionArea on ContentfulConversionArea {
    ...ContentfulEntry
    title {
      rich
    }
    ctaRef {
      ...ContentfulCta
    }
  }
`

export default withDisplayName(
  ContentfulConversionArea,
  'ContentfulConversionArea'
)
